// MainLayout.tsx
import React, { useState, useEffect, PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import QuickSendExample from './QuickSend';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setModuleGrants } from "../redux/actions/authActions";
import { fetchModuleGrants } from "../utils/moduleGrants";
// Explicitly include children in the props type
type MainLayoutProps = PropsWithChildren<{}>;
const MainLayout = ({ children }: MainLayoutProps) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const toggleSidebar = () => setIsSidebarCollapsed(!isSidebarCollapsed);
  const [openQuickSend, setOpenQuickSend] = useState(false);
  const handleQuickSend = () => setOpenQuickSend(true);
  const handleCloseQuickSend = () => setOpenQuickSend(false);
  const dispatch = useDispatch();

  // Login stores the per-user grants, but Settings → Authorization can change
  // them at any time. Re-read once per page load so a change applies without
  // signing out; until it answers, the stored copy is used.
  useEffect(() => {
    const token = localStorage.getItem("remnutri_auth_token");
    if (!token) return;
    let cancelled = false;
    fetchModuleGrants(token).then((grants) => {
      // undefined = could not be read; keep what login stored.
      if (!cancelled && grants !== undefined) dispatch(setModuleGrants(grants));
    });
    return () => {
      cancelled = true;
    };
  }, [dispatch]);
  return (
    <div className="app-shell flex overflow-hidden bg-[#f4f4f4]">
      <ToastContainer position="top-center" autoClose={2000} />

      <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />
      <main className="flex flex-1 min-w-0 min-h-0 flex-col overflow-y-auto">
        <div className="sticky top-0 z-20 border-b bg-gray-50/95 backdrop-blur supports-[backdrop-filter]:bg-gray-50/75">
          <TopBar onHandleQuickSend={handleQuickSend} />
        </div>

        {/*
          * min-w-0 matters as much as min-h-0 beside it.
          *
          * A flex item will not shrink below its own content, so a page with a
          * wide table — the meals list gained a column and tipped over the
          * edge — stretched this wrapper instead of scrolling inside its own
          * overflow-x-auto container. The whole page then scrolled sideways,
          * carrying the sticky top bar out of view with it.
          *
          * main already has it; this one was missed, and it is the one the
          * pages are actually rendered into.
          */}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          {children ?? <Outlet />}
          {openQuickSend && (
            <QuickSendExample handleCloseQuickSend={handleCloseQuickSend} />
          )}
        </div>
      </main>
    </div>

  );
};

export default MainLayout;
